class UserInfoModel {
  employeeId?: string
  carrotUserId?: string
  eligibilityDate?: string
  firstName?: string
  lastName?: string
  fullName?: string
  journey?: string
  interest?: string
  interestSpecificData?: string
  customInterest?: string
  talkedToDoctor?: string
  sex?: string
  genderIdentity?: string
  dateOfBirth?: string
  partnerFirstName?: string
  partnerLastName?: string
  partnerDateOfBirth?: string
  partnerSex?: string
  partnerEmail?: string
  personalEmail?: string
  emailOptIn?: boolean
  partnerGenderIdentity?: string
  email?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
  nonUsaAddress?: string
  isUsa?: boolean
  hasBankInfoFilledOut?: boolean
  hasCardholderId?: boolean
  cardState?: string
  phoneNumber?: string
  // We're missing lots of fields. The following are fields added some time after
  deductibleStatus?: string
  memberHasLegalPartner?: boolean
  memberCoverageType?: string
  memberCoverageTypeSelectValue?: string
  partnerCoverageTypeSelectValue?: string
  memberPlanSource?: string
  memberPlanSourceSelectValue?: string
  memberHasHSA?: boolean
  partnerCoverageType?: string
  partnerPlanSource?: string
  partnerPlanSourceSelectValue?: string
  partnerHasHSA?: boolean
  memberId?: string
  selectedTradingPartnerId?: string
  selectedTradingPartnerPk?: number
  memberCoverageStartDate?: string
  memberCoverageEndDate?: string
  partnerCoverageStartDate?: string
  partnerCoverageEndDate?: string
  legallyMarried?: boolean
  partnerAsDependent?: boolean
}

export { UserInfoModel }
